<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light my-auto">
      <div class="container-fluid">
        <div class="col-6 col-sm-2 order-2 order-sm-3 navbar-brand">
          <a @click="logout()" class="d-inline float-right btn-hc-dh">Logout</a>
        </div>
        <div class="col-6 col-sm-2 order-1 order-sm-1 icons">
          <ul class="my-auto">
            <li class="d-inline">
              <router-link :to="{ name: 'landingPage' }"><img src="@/assets/img/home_icon.png" alt="Home"></router-link>
            </li>
          </ul>
        </div>

        <div v-if="hasSearch" class="col-12 col-sm-8 order-3 order-sm-2 no-pad">
          <div class="input-group mobile-space-t db_search">
            <input v-model="searchId" @keyup="search" class="form-control form-control-lg" type="text"
              placeholder="Search" aria-label="Search">
            <div class="input-group-append">
              <span class="input-group-text amber lighten-3" id="basic-text1">
                <i class="fa fa-search text-grey" aria-hidden="true"></i>
              </span>
            </div>
          </div>
          <div class="col-sm-12 no-pad bg-white db-search-results">
            <div v-if="(results && (results == 0 || !results)) && searchId.length > 0" class="row">
              <div class="col-sm">
                <div class="mx-auto p-3">
                  <h5>Search Results:</h5>
                  <p class="d-inline">Sorry, no results found just yet......</p>
                </div>
              </div>
            </div>
            <div v-else-if="results && results.length >= 1 && searchId.length > 2" class="row">
              <div class="col-sm">
                <div class="mx-auto p-3">
                  <template>
                    <div class="table-responsive-lg pre-scrollable">
                      <b-table @row-clicked="setCustomer" responsive hover outlined striped :items="results"
                        :fields="searchResultFields">
                        <template slot="ref" slot-scope="data">
                          {{data.item.ref}}
                        </template>
                        <template slot="name" slot-scope="data">
                          {{data.item.name}}
                        </template>
                        <template slot="address" slot-scope="data">
                          {{data.item.address}}
                        </template>
                        <template slot="status" slot-scope="data">
                          <b-badge v-if="data.item.Document.IsBillable" class="pill my-auto" variant="success">Active</b-badge>
                          <b-badge v-else class="pill my-auto" variant="secondary">Inactive</b-badge>
                        </template>
                      </b-table>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div v-if="isTestEnvironment" class="bg-danger p-2 text-center my-auto">
      <div class="container-fluid">
        <p class="my-auto text-white font-weight-bold">************ WARNING! THIS IS {{environmentName.toUpperCase()}}, NOT A LIVE ENVIRONMENT! ************</p>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    props: ['hasSearch'],
     data() {
      return {
        searchId: '',
        searchResultFields: {
          ref: {
            key: 'Document.CustomerReference',
            label: 'Customer Reference',
            sortable: true,
            'class': 'text-center'
          },
          name: {
            key: 'Document.CustomerName',
            label: 'Customer Name',
            sortable: true,
            'class': 'text-center'
          },
          address: {
            key: 'Document.Addresses[0]',
            label: 'Customer Address',
            'class': 'text-center'
          },
          status: {
            label: 'Status',
            'class': 'text-center'
          },
        },
      }
    },
    computed: {
      results() {
          return this.$store.state.results;
      },
      environmentName() {
        return Vue.config.honeycomb.environment
      },
      isTestEnvironment() {
        return Vue.config.honeycomb.environmentType == 'test'
      }
    },
    methods: {
      search: function() {
        this.$store.dispatch('search', this.searchId);
      },
      setCustomer: function (result) {
        this.$store.dispatch('setCustomer', result.Document.CustomerReference);
        this.searchId = '';
        this.$store.commit('resetResults');
        this.$router.push("/dashboard/" + result.Document.CustomerReference);
      },
      logout() {
        // deletes the currently stored accessToken and redirects to the authStyle's logout endpoint
        this.$store.commit('updatePermissionAreas', null)
        this.$auth.logout();
      },
  },
  created() {
  this.$store.commit('resetResults');
  },
}
</script>
